import React, { useState, useEffect } from "react";
import { useQueries } from 'react-query'
import { getResultsRSC } from "data/Querys"
import { getLongPhaseRSC, getPhase, getPhaseRSC, getSex } from "helpers/rsc"
import { isStartListStatus } from "helpers/status";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStop, faCircle, faCaretUp, faPlus, faMinus,
} from "@fortawesome/free-solid-svg-icons";
import { getEvent, getLongEventRSC } from "helpers/rsc"
import Label from "components/general/Label"
import Loader from 'components/general/Loader'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ArcResultsIndividual from "components/sports/arc/views/ArcResultsIndividual";
import ArcResultsTeam from "components/sports/arc/views/ArcResultsTeam";
import OlympicRoundTeam from "components/sports/arc/views/ArcOlympicRoundTeam";
import ScoreHorizontal from "components/common/ScoreHorizontal";
import NotAvailable from "components/common/NotAvailable";
import Button from 'react-bootstrap/Button';
import { findArray } from 'helpers/utils';
import PageHeader from "components/common/PageHeader";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import ProgressionRule from "components/common/ProgressionRule";
import RecordsPrototype from "components/general/RecordsPrototype";


const ArcContext = () => {
  const { mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()

  let phase = getPhase(mirs_rsc);
  let sex = getSex(mirs_rsc);
  let queryArray = [];
  let rscArray = [];
  if (getEvent(mirs_rsc) === 'INDIVID-----------') {
    rscArray = [mirs_rsc, `ARC${sex}TEAM3-------------QUAL000100--`, 'ARCXTEAM2-------------QUAL000100--']
  } else if (getEvent(mirs_rsc) === 'INDIVIDC----------') {
    rscArray = [mirs_rsc, 'ARCXTEAM2C------------QUAL000100--']
  } else if (getEvent(mirs_rsc) === 'INDIVID-01010-----') {         //pARC W1 RR
    rscArray = [mirs_rsc, 'ARCXTEAM----01010-----QUAL000100--']
  } else if (getEvent(mirs_rsc) === 'INDIVIDC99030-----') {         //pARC Compound RR
    rscArray = [mirs_rsc, 'ARCXTEAMC---99030-----QUAL000100--']
  } else if (getEvent(mirs_rsc) === 'INDIVIDR99030-----') {         //pARC Recurve RR
    rscArray = [mirs_rsc, 'ARCXTEAMR---99030-----QUAL000100--']
  } else {
    rscArray = [mirs_rsc]
  }
  rscArray.forEach((rsc) => {
    queryArray.push({
      queryKey: ['resultsData', mirs_competition, rsc, mirs_language, getLongEventRSC(rsc)],
      queryFn: getResultsRSC,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    })
  });

  const results = useQueries(queryArray);
  const isLoading = results.some(result => result.isLoading)
  const isError = results.some(result => result.isError)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  if (isError) { return <NotAvailable />; }
  if (isLoading) { return <Loader />; }

  let out = (phase === 'QUAL') ? <RankingRound data={results} /> : <OlympicRound data={results[0]?.data} />

  return (
    <>
      {results[0]?.data?.results ? (
        <>
          <PageHeader data={results[0]?.data} />
          <div className='mirs-page-container'>
            {out}
          </div>
        </>
      ) : (
        <span><em>No data available</em></span>
      )
      }
    </>
  )

}

function RankingRound({ data }) {
  const { mirs_rsc } = useUrlFriendlyToParameters()
  const [key, setKey] = useState(`1-${mirs_rsc}`);
  let resultStatus;
  let dtRecord;
  switch (key) {
    case `1-${mirs_rsc}`:
      dtRecord = data[0]?.data?.records?.filter(item => getPhase(item?.recordCode) === getPhase(mirs_rsc))
      resultStatus = data[0]?.data?.results?.status?.code
      break
    case `2-${mirs_rsc}`:
      dtRecord = data[1]?.data?.records?.filter(item => getPhase(item?.recordCode) === getPhase(mirs_rsc))
      resultStatus = data[1]?.data?.results?.status?.code
      break
    case `3-${mirs_rsc}`:
      dtRecord = data[2]?.data?.records?.filter(item => getPhase(item?.recordCode) === getPhase(mirs_rsc))
      resultStatus = data[2]?.data?.results?.status?.code
      break
  }

  if (getEvent(mirs_rsc) === 'INDIVID-----------') {
    const filtersQualRule = {
      type: ['QUALIFICATION'],
      code: ['QUAL_RULE']
    };

    return (
      <>
        {
          dtRecord &&
          <RecordsPrototype records={dtRecord} forceResultTypeHader="HeaderScore" forceMobileColumns={['Date', 'Location']} />
        }

        {data[0]?.data?.results ? (
          <>
            {key === `3-${mirs_rsc}` && <ProgressionRule key="progress-component" data={data[2]?.data?.config?.extendedConfig} filter={filtersQualRule} itemData={'value'} />}
            <Tabs
              id="mirs-navsport"
              className="mb-3 mirs-tab-result"
              defaultActiveKey={`1-${mirs_rsc}`}
              onSelect={(k) => setKey(k)}>
              <Tab eventKey={`1-${mirs_rsc}`} title={<Label data="HeaderIndividual" />} >
                <ArcResultsIndividual
                  data={data[0]?.data}
                  caption={<Label data=
                    {isStartListStatus(resultStatus)
                      ? "HeaderStartList"
                      : "HeaderResults"
                    }
                  />} />
              </Tab>
              <Tab eventKey={`2-${mirs_rsc}`} title={<Label data="HeaderTeam" />} >
                <ArcResultsTeam
                  data={data[1]?.data}
                  caption={<Label data=
                    {isStartListStatus(resultStatus)
                      ? "HeaderStartList"
                      : "HeaderResults"
                    }
                  />} />
              </Tab>
              <Tab eventKey={`3-${mirs_rsc}`} title={<Label data="HeaderMixedTeam" />} >
                <ArcResultsTeam
                  data={data[2]?.data}
                  caption={<Label data=
                    {isStartListStatus(resultStatus)
                      ? "HeaderStartList"
                      : "HeaderResults"
                    }
                  />} />
              </Tab>
            </Tabs>

          </>
        ) : (
          <span><em>No data available</em></span>
        )
        }
      </>
    )
  } else if (getEvent(mirs_rsc) === 'INDIVIDC----------') {
    return (
      <>
        {
          dtRecord &&
          <RecordsPrototype records={dtRecord} forceResultTypeHader="HeaderScore" forceMobileColumns={['Date', 'Location']} />
        }

        {data[0]?.data?.results ? (
          <>
            <Tabs
              id="mirs-navsport"
              className="mb-3 mirs-tab-result"
              defaultActiveKey={`1-${mirs_rsc}`}
              onSelect={(k) => setKey(k)}>
              <Tab eventKey={`1-${mirs_rsc}`} title={<Label data="HeaderIndividual" />} >
                <ArcResultsIndividual
                  data={data[0]?.data}
                  caption={<Label data=
                    {isStartListStatus(resultStatus)
                      ? "HeaderStartList"
                      : "HeaderResults"
                    }
                  />} />
              </Tab>
              <Tab eventKey={`2-${mirs_rsc}`} title={<Label data="HeaderMixedTeam" />} >
                <ArcResultsTeam
                  data={data[1]?.data}
                  caption={<Label data=
                    {isStartListStatus(resultStatus)
                      ? "HeaderStartList"
                      : "HeaderResults"
                    }
                  />} />
              </Tab>
            </Tabs>

          </>
        ) : (
          <span><em>No data available</em></span>
        )
        }
      </>
    )
  } else if (getEvent(mirs_rsc) === 'INDIVID-01010-----') {     //pARC W1 RR
    return (
      <>
        {data[0]?.data?.results ? (
          <>
            <Tabs
              id="mirs-navsport"
              className="mb-3 mirs-tab-result"
              defaultActiveKey={`1-${mirs_rsc}`}
              onSelect={(k) => setKey(k)}>
              <Tab eventKey={`1-${mirs_rsc}`} title={<Label data="HeaderIndividual" />} >
                <ArcResultsIndividual
                  data={data[0]?.data}
                  caption={<Label data=
                    {isStartListStatus(resultStatus)
                      ? "HeaderStartList"
                      : "HeaderResults"
                    }
                  />} />
              </Tab>
              <Tab eventKey={`2-${mirs_rsc}`} title={<Label data="HeaderMixedTeam" />} >
                <ArcResultsTeam
                  data={data[1]?.data}
                  caption={<Label data=
                    {isStartListStatus(resultStatus)
                      ? "HeaderStartList"
                      : "HeaderResults"
                    }
                  />} />
              </Tab>
            </Tabs>

          </>
        ) : (
          <span><em>No data available</em></span>
        )
        }
      </>
    )
  }
  else if (getEvent(mirs_rsc) === 'INDIVIDC99030-----') {     //pARC Compound RR
    return (
      <>
        {data[0]?.data?.results ? (
          <>
            <Tabs
              id="mirs-navsport"
              className="mb-3 mirs-tab-result"
              defaultActiveKey={`1-${mirs_rsc}`}
              onSelect={(k) => setKey(k)}>
              <Tab eventKey={`1-${mirs_rsc}`} title={<Label data="HeaderIndividual" />} >
                <ArcResultsIndividual
                  data={data[0]?.data}
                  caption={<Label data=
                    {isStartListStatus(resultStatus)
                      ? "HeaderStartList"
                      : "HeaderResults"
                    }
                  />} />
              </Tab>
              <Tab eventKey={`2-${mirs_rsc}`} title={<Label data="HeaderMixedTeam" />} >
                <ArcResultsTeam
                  data={data[1]?.data}
                  caption={<Label data=
                    {isStartListStatus(resultStatus)
                      ? "HeaderStartList"
                      : "HeaderResults"
                    }
                  />} />
              </Tab>
            </Tabs>

          </>
        ) : (
          <span><em>No data available</em></span>
        )
        }
      </>
    )
  }
  else if (getEvent(mirs_rsc) === 'INDIVIDR99030-----') {     //pARC Recurve RR
    return (
      <>
        {data[0]?.data?.results ? (
          <>
            <Tabs
              id="mirs-navsport"
              className="mb-3 mirs-tab-result"
              defaultActiveKey={`1-${mirs_rsc}`}
              onSelect={(k) => setKey(k)}>
              <Tab eventKey={`1-${mirs_rsc}`} title={<Label data="HeaderIndividual" />} >
                <ArcResultsIndividual
                  data={data[0]?.data}
                  caption={<Label data=
                    {isStartListStatus(resultStatus)
                      ? "HeaderStartList"
                      : "HeaderResults"
                    }
                  />} />
              </Tab>
              <Tab eventKey={`2-${mirs_rsc}`} title={<Label data="HeaderMixedTeam" />} >
                <ArcResultsTeam
                  data={data[1]?.data}
                  caption={<Label data=
                    {isStartListStatus(resultStatus)
                      ? "HeaderStartList"
                      : "HeaderResults"
                    }
                  />} />
              </Tab>
            </Tabs>

          </>
        ) : (
          <NotAvailable />
        )
        }
      </>
    )
  }
}

function OlympicRound({ data }) {
  const { mirs_rsc, mirs_competition } = useUrlFriendlyToParameters()

  let home = findArray(data?.results?.items, { startSortOrder: [1] });
  let away = findArray(data?.results?.items, { startSortOrder: [2] });
  let isTeam = home?.participant?.__typename === 'Team' || away?.participant?.__typename === 'Team'
  let playerForTeam;
  let extendedStartList;
  const [openESL, setOpenESL] = useState(false);
  if (home?.extCompetitor || away?.extCompetitor || home?.teamAthletes?.extCompetitor || away?.teamAthletes?.extCompetitor) {
    extendedStartList = <div id='extended-start-list'>
      {home?.extCompetitor ? <div className="mb-2">{home?.extCompetitor}</div> : ''}
      {away?.extCompetitor ? <div>{away?.extCompetitor}</div> : ''}
      {home?.teamAthletes?.extCompetitor ? <div>{home?.teamAthletes?.extCompetitor}</div> : ''}
      {away?.teamAthletes?.extCompetitor ? <div>{away?.teamAthletes?.extCompetitor}</div> : ''}
    </div>
  } else {
    extendedStartList = '';
  }

  if (isTeam) {
    playerForTeam = <>
      <div className="flex-column d-flex w-100" >
        <div className="d-flex justify-content-center">
          <div key='ScoreHome' className='score-horizontal-extra-information-box text-end w-45'>
            {home?.teamAthletes && home?.teamAthletes?.sort((a, b) => a.order - b.order).map((item, key) => (

              <div key={'OlympicRoundHome-' + item?.code + key} className="d-flex justify-content-end">
                <span className="d-none d-md-block">{item?.athlete?.name}</span>
                <span className="d-block d-md-none">{item?.athlete?.shortName}</span>&nbsp;
                {data?.results?.eventUnitCode.substring(3, 4) === 'X' ? item?.athlete?.personGender?.code : ''}&nbsp;
                {item?.order === 1 ? <FontAwesomeIcon className='align-self-center' icon={faStop} /> : ''}
                {item?.order === 2 ? <FontAwesomeIcon className='align-self-center' icon={faCaretUp} /> : ''}
                {item?.order === 3 ? <FontAwesomeIcon className='align-self-center' icon={faCircle} /> : ''}
              </div>

            )
            )}
          </div>

          <div key='ScoreCenter' className='score-horizontal-extra-information-box w-10'></div>

          <div key='ScoreAway' className='score-horizontal-extra-information-box text-start w-45'>
            {away?.teamAthletes && away?.teamAthletes?.sort((a, b) => a.order - b.order).map((item, key) => (

              <div key={'OlympicRoundAway-' + item?.code + key} className="d-flex">
                {item?.order === 1 ? <FontAwesomeIcon className='align-self-center' icon={faStop} /> : ''}
                {item?.order === 2 ? <FontAwesomeIcon className='align-self-center' icon={faCaretUp} /> : ''}
                {item?.order === 3 ? <FontAwesomeIcon className='align-self-center' icon={faCircle} /> : ''}
                &nbsp;<span className="d-none d-md-block">{item?.athlete?.name}</span>
                <span className="d-block d-md-none">{item?.athlete?.shortName}</span>&nbsp;
                {data?.results?.eventUnitCode.substring(3, 4) === 'X' ? item?.athlete?.personGender?.code : ''}
              </div>

            )
            )}
          </div>
        </div>
      </div>
    </>
  } else {
    playerForTeam = '';
  }
  let showRecord = getEvent(mirs_rsc) === 'INDIVIDC----------' || getEvent(mirs_rsc) === 'TEAM2C------------';
  let dtRecord = data?.records?.filter(item => getPhase(item?.recordCode) === 'MTCH')
  return (
    <>
        {
          showRecord && dtRecord &&
          <RecordsPrototype records={dtRecord} forceResultTypeHader="HeaderScore" forceMobileColumns={['Date', 'Location']} />
        }

      <ScoreHorizontal
        data={data}
        scoreHeader={{
          left: data?.results?.eventUnit?.description
        }}
        scoreBody={{
          bottom: playerForTeam
        }}
        scoreFooter={{
          top: extendedStartList && <div className="w-100 d-flex justify-content-end"><div><Button variant="outline-secondary" onClick={() => setOpenESL(!openESL)} aria-controls='extended-start-list' aria-expanded={openESL}><FontAwesomeIcon icon={openESL ? faMinus : faPlus} /></Button></div></div>,
          bottom: openESL && extendedStartList
        }}
      />
      <OlympicRoundTeam data={data} />
    </>
  )
}
export default ArcContext;